// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"196":"df648f58","325":"3376f474","856":"da8b9d72","935":"1fdce82f"}[chunkId] + ".js";
};